import React, { useState } from "react";

const Itjobapplypage = () => {
    const jobs = [
        {
            id: 1,
            title: "React Js Developer",
            location: "Remote",
            description: "Develop and maintain applications...",
        },
        {
            id: 2,
            title: "Java Developer",
            location: "New York, NY",
            description: "Lead product strategy and execution...",
        },
        {
            id: 3,
            title: "Flutter Developer",
            location: "San Francisco, CA",
            description: "Create intuitive and beautiful user interfaces...",
        },
    ];

    return (
        <div className="app">
            <JobListings jobs={jobs} />
        </div>
    );
};

const JobListings = ({ jobs }) => {
    const [selectedJob, setSelectedJob] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleApplyClick = (job) => {
        setSelectedJob(job);
        setShowModal(true);
    };

    return (
        <section className="job-listings">
            <h2 style={{ color: "#fff", fontSize: '55px' }}>Current Openings</h2>
            <div className="job-cards-container">
                {jobs.map((job) => (
                    <div key={job.id} className="job-card">
                        <h3>{job.title}</h3>
                        <p>{job.location}</p>
                        <p>{job.description}</p>
                        <button
                            onClick={() => handleApplyClick(job)}
                            className="apply-button"
                        >
                            Apply Now
                        </button>
                    </div>
                ))}
            </div>

            {/* Modal for Job Application Form */}
            {showModal && selectedJob && (
                <JobApplication
                    job={selectedJob}
                    closeForm={() => setShowModal(false)}
                />
            )}
        </section>
    );
};

const JobApplication = ({ job, closeForm }) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [cv, setCv] = useState(null);
    const [coverLetter, setCoverLetter] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        alert(`Application submitted for ${job.title}`);
        closeForm(); // Close the modal after submission
    };

    return (
        <div className="modal-overlay" onClick={closeForm}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                {/* Close Button */}
                <button
                    className="close-btn"
                    onClick={closeForm}
                    style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        fontSize: "24px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#000",
                    }}
                >
                    &times;
                </button>

                <h2>Apply for {job.title}</h2>
                <form onSubmit={handleSubmit}>
                    <label htmlFor="name">Full Name:</label>
                    <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />

                    <label htmlFor="email">Email Address:</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />

                    <label htmlFor="cv">Upload CV (PDF or DOCX):</label>
                    <input
                        type="file"
                        id="cv"
                        onChange={(e) => setCv(e.target.files[0])}
                        accept=".pdf, .docx"
                        required
                    />

                    <label htmlFor="coverLetter">Cover Letter:</label>
                    <textarea
                        id="coverLetter"
                        value={coverLetter}
                        onChange={(e) => setCoverLetter(e.target.value)}
                    />

                    <button type="submit">Submit Application</button>
                    {/* <button
                        type="button"
                        onClick={closeForm}
                        style={{ marginLeft: "10px", backgroundColor: "#f44336" }}
                     >
                        Cancel
                    </button> */}
                </form>
            </div>
        </div>
    );
};

// Internal CSS for styling
const styles = `
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  color: #000;
}

.close-btn:hover {
  color: #f44336; /* Red color on hover */
}
  .app {
    text-align: center;
  }

  .job-listings {
    padding: 20px;
    background: #0a839b;
    height: 450px;
  }

  .job-cards-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;
  }

  .job-card {
    flex: 1;
    max-width: 30%;
    border: 1px solid #ddd;
    padding: 20px;
    background-color: white;
    border-radius: 5px;
    box-sizing: border-box;
  }

  .job-card h3 {
    font-size: 1.5rem;
  }

  .apply-button {
    display: inline-block;
    padding: 10px 20px;
    background-color: #4caf50;
    color: white;
    text-decoration: none;
    border-radius: 5px;
    margin-top: 10px;
    cursor: pointer;
  }

  .apply-button:hover {
    background-color: #edcf39;
    color: #000;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    width: 400px;
    max-width: 90%;
    box-sizing: border-box;
  }

  form label {
    display: block;
    margin-bottom: 5px;
  }

  form input, form textarea {
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  form button {
    background-color: #4caf50;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  form button:hover {
    background-color: #45a049;
  }

  form button[type="button"] {
    background-color: #f44336;
  }

  form button[type="button"]:hover {
    background-color: #e53935;
  }


@media (max-width: 768px) {

 .job-listings {
    padding: 20px;
    background: #0a839b;
    height: 1000px;
  }
    /* Adjust the job cards layout for smaller screens */
    .job-cards-container {
      flex-direction: column;
      gap: 10px;
    }
  
    .job-card {
      max-width: 100%; /* Ensure the cards take full width on smaller screens */
    }
  
    /* Make modal content width responsive */
    .modal-content {
      width: 90%; /* Ensure the modal takes 90% of the screen width */
      max-width: 400px; /* Limit the max width */
    }
  
    .modal-overlay {
      padding: 20px;
    }
  
    /* Make buttons more accessible on small screens */
    form button {
      padding: 12px 24px;
    }
  }
  
  @media (max-width: 480px) {
    /* Further adjustments for mobile screens */
    .job-card {
      padding: 15px; /* Reduce padding in job cards */
    }
  
    .job-cards-container {
      padding: 0 15px;
    }
  
    .modal-content {
      padding: 15px;
    }
  
    .close-btn {
      font-size: 20px; /* Make close button smaller on mobile */
    }
  
    form input, form textarea {
      padding: 8px; /* Adjust padding for inputs and textarea */
    }
  }
`;

const addStyles = () => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
};

addStyles();

export default Itjobapplypage;
